import React, { FC } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import NavBarList from '../navigationBar';
import { NavigationBarModel } from './models/breadcrumbBar.model';
import { TNavigationBarBreadcrumbItem, TNavigationBarProps } from './types/breadcrumbBar.types';
import UnreleasedComponent from '../unreleasedComponent';

const SharedBreadcrumbBar: FC<WithTranslation & TNavigationBarProps> = (props) => {
  const model = new NavigationBarModel(props);

    const getItemWithModifiedUrl = (item: TNavigationBarBreadcrumbItem): TNavigationBarBreadcrumbItem => {
    if (props?.appendQueryParams) {
      return {
        ...item,
        url: props.appendQueryParams(item.url),
      };
    }

    return item;
  };

  const getModifiedBackButtonUrl = (url: string) => {
    if (props?.appendQueryParams) {
      return props.appendQueryParams(url);
    }
    return url;
  };

  // Component is unreleased
  if (model.isUnreleased) {
      return <UnreleasedComponent/>
  }

  return (
    <>
            <Helmet script={[model.breadcrumbJSONLD]}/>
      <NavBarList
        breadcrumbItems={model.breadcrumbItems.map((item) => getItemWithModifiedUrl(item))}
        backButtonUrl={getModifiedBackButtonUrl(model.backButtonUrl)}
        backButtonLabel={model.backButtonLabel}
      />
    </>
  );
};

export default withTranslation()(SharedBreadcrumbBar);
